import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "profilePage",
  class: "container mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col col-sm-12 profile-page" }
const _hoisted_4 = { class: "profile-main-wrapper" }
const _hoisted_5 = { class: "header-title" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = {
  key: 0,
  class: "row"
}
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "header-slug" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = {
  key: 1,
  class: "row"
}
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "header-slug" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "pb-3" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "customer-loader"
}
const _hoisted_18 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_19 = { class: "font-small error-color" }
const _hoisted_20 = {
  key: 0,
  class: "font-small success-color"
}
const _hoisted_21 = { class: "pt-3" }
const _hoisted_22 = { class: "header-slug" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "customer-loader"
}
const _hoisted_27 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_28 = { class: "font-small error-color" }
const _hoisted_29 = {
  key: 0,
  class: "font-small success-color"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerProfileNavComponent = _resolveComponent("CustomerProfileNavComponent")!
  const _component_InputComponent = _resolveComponent("InputComponent")!
  const _component_PasswordRequirementsCardComponent = _resolveComponent("PasswordRequirementsCardComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomerProfileNavComponent, {
        id: "sideNav",
        class: "col-lg-4 col-sm-12 side-nav"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t('profile_page_title')), 1),
          _createElementVNode("div", _hoisted_6, [
            (! this.store.state.customer.company_name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('personal_info')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerForm.inputs, (input) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_InputComponent, {
                        class: "profile-input",
                        "name-input": input.name,
                        "data-type": input.dataType,
                        placeholder: _ctx.$t(input.placeholder),
                        data: input.value,
                        "onUpdate:data": ($event: any) => ((input.value) = $event),
                        msg: input.validation
                      }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"])
                    ]))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('company_info')), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyForm.inputs, (input) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_InputComponent, {
                        class: "profile-input",
                        "name-input": input.name,
                        "data-type": input.dataType,
                        placeholder: _ctx.$t(input.placeholder),
                        data: input.value,
                        "onUpdate:data": ($event: any) => ((input.value) = $event),
                        msg: input.validation
                      }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"])
                    ]))
                  }), 256))
                ])),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("button", {
                class: _normalizeClass(["button", {'less-padding-06': _ctx.loading}]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                disabled: _ctx.loading
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('save')), 1),
                (_ctx.customerForm.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_16),
              (_ctx.customerForm.errors.length || _ctx.customerForm.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerForm.errors, (error) => {
                      return (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t(error)), 1))
                    }), 256)),
                    (_ctx.customerForm.success)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('saved')), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('change_password')), 1),
              _createVNode(_component_PasswordRequirementsCardComponent),
              _createElementVNode("div", _hoisted_23, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordForm.inputs, (input) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_InputComponent, {
                      class: "profile-input",
                      "name-input": input.name,
                      "data-type": input.dataType,
                      placeholder: _ctx.$t(input.placeholder),
                      data: input.value,
                      "onUpdate:data": ($event: any) => ((input.value) = $event),
                      msg: input.validation
                    }, null, 8, ["name-input", "data-type", "placeholder", "data", "onUpdate:data", "msg"])
                  ]))
                }), 256))
              ])
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["button", {'less-padding-06': _ctx.loading}]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitPasswordUpdate())),
              disabled: _ctx.loading
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('change')) + " ", 1),
              (_ctx.passwordForm.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                : _createCommentVNode("", true)
            ], 10, _hoisted_25),
            (_ctx.passwordForm.errors.length || _ctx.passwordForm.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordForm.errors, (error) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t(error)), 1))
                  }), 256)),
                  (_ctx.passwordForm.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('saved')), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}